'use client';
import { useInactivity, useRefreshAccessToken } from '@quick/auth';

import { envs } from '@/layers/core/data/const';

export function useValidateToken() {
  useInactivity();
  useRefreshAccessToken(`${envs.quickApi}/users/v2/refresh_token`);
}
